/* Irissale — Runway. Initialises every .irs-runway on the page. */
(function () {
  var OFFSET = [0, 0.237, 0.381, 0.462];
  var SCALE = [1, 0.380, 0.355, 0.330];
  var OFFSET_SM = [0, 0.400, 0.700, 0.700];
  var SCALE_SM = [1, 0.420, 0.380, 0.380];
  var DRAG_PX = 14;

  function init(root) {
    if (root.dataset.irsReady) return;
    root.dataset.irsReady = '1';

    var LOOKS = [];
    var holder = root.querySelector('[data-irs-data]');
    try { LOOKS = JSON.parse(holder.textContent) || []; } catch (e) { return; }
    LOOKS = LOOKS.filter(function (l) { return l.frames && l.frames.length; });
    if (!LOOKS.length) return;

    var SPIN_MS = parseInt(root.dataset.spinSpeed || '90', 10);
    var AUTOSPIN = root.dataset.autospin === 'true';
    var ATC = root.dataset.atcLabel || 'add to cart';
    var OOS = root.dataset.oosLabel || 'out of stock';
    var PRE = root.dataset.preorderLabel || 'Preorder';
    var PRE_NOTE = root.dataset.preorderNote || '';
    var PRE_CART_NOTE = root.dataset.preorderCartNote || '';

    var stage = root.querySelector('[data-irs-stage]');
    var dots = root.querySelector('[data-irs-dots]');
    var panels = root.querySelectorAll('[data-irs-panel]');
    var elName = root.querySelector('[data-irs-name]');
    var elDesc = root.querySelector('[data-irs-desc]');
    var elPrice = root.querySelector('[data-irs-price]');
    var elSizes = root.querySelector('[data-irs-sizes]');
    var elAtc = root.querySelector('[data-irs-atc]');
    var elVid = root.querySelector('[data-irs-vid]');
    var elProp = root.querySelector('[data-irs-prop]');
    var elNote = root.querySelector('[data-irs-note]');

    var active = 0, vIdx = 0, frameIdx = 0, timer = null, nodes = [], cache = {};
    var small = function () { return window.matchMedia('(max-width:749px)').matches; };

    function preload(i) {
      (LOOKS[i].frames || []).forEach(function (u) {
        if (cache[u]) return;
        var im = new Image(); im.src = u; cache[u] = im;
      });
    }

    LOOKS.forEach(function (look, i) {
      var el = document.createElement('div');
      el.className = 'irs-look';
      var img = document.createElement('img');
      img.src = look.frames[0];
      img.alt = look.title;
      img.loading = i < 3 ? 'eager' : 'lazy';
      img.draggable = false;
      el.appendChild(img);
      el.addEventListener('click', function () { go(i); });
      stage.appendChild(el);
      nodes.push(el);

      if (dots) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', look.title);
        b.addEventListener('click', function () { go(i); });
        dots.appendChild(b);
      }
    });

    function delta(i) {
      var n = LOOKS.length, d = i - active;
      if (d > n / 2) d -= n;
      if (d < -n / 2) d += n;
      return d;
    }

    function layout() {
      var w = stage.clientWidth, sm = small();
      var off = sm ? OFFSET_SM : OFFSET, sc = sm ? SCALE_SM : SCALE, edge = sm ? 2 : 3;
      nodes.forEach(function (el, i) {
        var d = delta(i), a = Math.min(Math.abs(d), off.length - 1);
        var x = Math.sign(d) * off[a] * w;
        el.style.transform = 'translateX(calc(-50% + ' + x + 'px)) scale(' + sc[a] + ')';
        el.style.zIndex = String(10 - a);
        el.classList.toggle('is-active', d === 0);
        el.classList.toggle('can-spin', d === 0 && LOOKS[i].frames.length > 1);
        el.classList.toggle('is-hidden', Math.abs(d) >= edge);
        if (d !== 0) el.querySelector('img').src = LOOKS[i].frames[0];
      });
      if (dots) Array.prototype.forEach.call(dots.children, function (b, i) {
        b.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
    }

    function showFrame(n) {
      var f = LOOKS[active].frames;
      frameIdx = ((n % f.length) + f.length) % f.length;
      nodes[active].querySelector('img').src = f[frameIdx];
    }
    function stopSpin() { if (timer) { clearInterval(timer); timer = null; } }
    function startSpin() {
      stopSpin();
      if (!AUTOSPIN) return;
      if (LOOKS[active].frames.length < 3) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () { showFrame(frameIdx + 1); }, SPIN_MS);
    }

    function paintSizes() {
      Array.prototype.forEach.call(elSizes.children, function (b, i) {
        b.setAttribute('aria-pressed', i === vIdx ? 'true' : 'false');
      });

      var v = LOOKS[active].variants[vIdx];
      if (v) elVid.value = v.id;

      var sold = !(v && v.available);
      var pre = !sold && v.preorder === true;

      elAtc.disabled = sold;
      elAtc.textContent = sold ? OOS : (pre ? PRE : ATC);

      if (elProp) {
        elProp.disabled = !pre;
        elProp.value = pre ? PRE_CART_NOTE : '';
      }
      if (elNote) {
        elNote.textContent = pre ? PRE_NOTE : '';
        elNote.hidden = !pre || !PRE_NOTE;
      }
    }

    function paint() {
      var l = LOOKS[active];
      panels.forEach(function (p) { p.classList.add('is-swapping'); });
      setTimeout(function () {
        elName.textContent = l.title;
        elName.href = l.url;
        elDesc.textContent = l.desc || '';
        elPrice.innerHTML = l.priceText;

        elSizes.innerHTML = '';
        l.variants.forEach(function (v, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.textContent = v.title;
          if (v.preorder === true) b.setAttribute('data-preorder', 'true');
          if (!v.available) b.disabled = true;
          b.addEventListener('click', function () { vIdx = i; paintSizes(); });
          elSizes.appendChild(b);
        });

        // Prefer a size that is in stock; fall back to a preorder size.
        var ok = -1;
        l.variants.forEach(function (v, i) {
          if (ok < 0 && v.available && v.preorder !== true) ok = i;
        });
        if (ok < 0) l.variants.forEach(function (v, i) { if (ok < 0 && v.available) ok = i; });
        vIdx = ok > -1 ? ok : 0;

        paintSizes();
        panels.forEach(function (p) { p.classList.remove('is-swapping'); });
      }, 300);
    }

    function go(i) {
      if (i === active) return;
      active = (i + LOOKS.length) % LOOKS.length;
      frameIdx = 0;
      preload(active);
      preload((active + 1) % LOOKS.length);
      preload((active - 1 + LOOKS.length) % LOOKS.length);
      layout(); paint(); startSpin();
    }

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(active + 1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { go(active - 1); e.preventDefault(); }
    });

    var dragX = null, onCentre = false, scrubbed = 0;
    root.addEventListener('pointerdown', function (e) {
      if (e.target.closest('[data-irs-panel]')) return;
      dragX = e.clientX; scrubbed = 0;
      onCentre = nodes[active].contains(e.target) && LOOKS[active].frames.length > 1;
      if (onCentre) stopSpin();
    });
    root.addEventListener('pointermove', function (e) {
      if (dragX === null || !onCentre) return;
      var steps = Math.trunc((e.clientX - dragX) / DRAG_PX);
      if (steps !== scrubbed) { showFrame(frameIdx + (steps - scrubbed)); scrubbed = steps; }
    });
    root.addEventListener('pointerup', function (e) {
      if (dragX === null) return;
      var dx = e.clientX - dragX, wasCentre = onCentre;
      dragX = null; onCentre = false;
      if (wasCentre) { startSpin(); return; }
      if (Math.abs(dx) > 42) go(active + (dx < 0 ? 1 : -1));
    });

    var wheelLock = false;
    root.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) < Math.abs(e.deltaY) || wheelLock) return;
      e.preventDefault();
      wheelLock = true;
      go(active + (e.deltaX > 0 ? 1 : -1));
      setTimeout(function () { wheelLock = false; }, 620);
    }, { passive: false });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        en[0].isIntersecting ? startSpin() : stopSpin();
      }, { threshold: 0.25 }).observe(root);
    }

    window.addEventListener('resize', layout);
    LOOKS.forEach(function (_, i) { if (i < 3) preload(i); });
    layout(); paint(); startSpin();
  }

  function boot() {
    document.querySelectorAll('.irs-runway').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
